var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import * as classnames from "classnames";
import { compose, withState, setDisplayName } from "recompose";
import Icon from "../Icon";
var enhance = compose(withState("isCollapsed", "setIsCollapsed", false), setDisplayName("Card"));
var Card = enhance(function (_a) {
    var children = _a.children, className = _a.className, wdsTitle = _a.wdsTitle, collapsible = _a.collapsible, isCollapsed = _a.isCollapsed, setIsCollapsed = _a.setIsCollapsed, otherProps = __rest(_a, ["children", "className", "wdsTitle", "collapsible", "isCollapsed", "setIsCollapsed"]);
    return (React.createElement("div", __assign({ className: classnames("wds-card", className) }, otherProps),
        wdsTitle && (React.createElement("header", { className: classnames("wds-card__header", {
                "wds-card__header--collapsed": isCollapsed
            }) },
            React.createElement("h1", { className: "wds-card__title wds-type--card-title" }, wdsTitle),
            collapsible && (React.createElement(Icon, { style: { cursor: "pointer" }, onClick: function () { return setIsCollapsed(!isCollapsed); } }, isCollapsed ? "á" : "Ÿ")))),
        React.createElement("div", { className: classnames("wds-card__body", {
                "wds-card__body--collapsed": isCollapsed
            }) }, children)));
});
export default Card;
//# sourceMappingURL=Card.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Card/Card.js
// module id = 1761
// module chunks = 17